import React, { useState, useEffect, useContext } from 'react';
import { ButtonHeading, CommonDateRange, PaymentDetailsTabs, SupplierDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import Ledger from '../Ledger';
import { useLocation, useNavigate } from 'react-router-dom';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Trip } from 'pages/Trip';
import { UserContext } from 'context';
import { AdjustBalanceModal, ConfirmModalFor, SupplierReport } from 'modals';
import moment from 'moment';
import SupplierSettingsTab from 'components/MastersDetailsTabs/SupplierSettingsTab/SupplierSettingsTab';
import './supplierMain.css'

const SupplierDetails = () => {
    useDocumentTitle("Supplier Details | T360");

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const supplierName = queryParams.get('name') || '';
    const [ledgerDetails, setLedgerDetails] = useState({});

    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const [supplierData, setSupplierData] = useState(null)
    const { setTRipFilter , setMasterDetailsList} = useContext(UserContext)
    const [openDate, setOpenDate] = useState(false)
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [refreshLedger, setRefreshLedger] = useState(false);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });
    const [openForDownLoad, setOpenForDownLoad] = useState(false)

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
    };

    useEffect(() => {
        setActiveTab(tabFromQuery);
    }, [tabFromQuery]);

    const handleActiveTabs = (e) => {
        if (e == 2) {
            // Trip tab - Set supplier filter with ID and name for proper prefill
            setTRipFilter((pre) => ({
                ...pre,
                supplier_id: supplierData?._id || '',
                supplier_name: supplierData?.name || ''
            }))
        } else {
            // Other tabs - Clear supplier filter
            setTRipFilter((pre) => ({
                ...pre,
                supplier_id: '',
                supplier_name: ''
            }))
        }
        setActiveTab(e)

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: constant.supplierDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab,
    };

    const handleSupplierData = (data) => {
        setSupplierData(data)
    }

    const OpenModalForDownload = () => {
        setOpenDate(false);
        setOpenForDownLoad(true)
    }

    const calback = () => {

        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    let confirmModalProps = {
        show: openDate,
        closeModal: (e) => {
            setOpenDate(false);
        },
        title: "Date Range",
        submitTitle: "Submit",
        onSubmit: OpenModalForDownload,
        confirmModal: "confirmModal",
        // icon: Images.DELETEICON.default,
        // isLoadding: deleteLoading,
        // disabled: deleteLoading,
    };

    let TripReoprtModal = {
        isOpen: openForDownLoad,
        closeModal: (e) => setOpenForDownLoad(false),
        modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
        footerPart: true,
        modalTitle: "Supplier Report",
        submitTitle: "Download",
        therdSubmitTitle: "Download",
        supplier_id: supplierData?._id,
        start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
        // confirmBox: (e) => setShowBackModal(true)
    }

    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Supplier",
        calback: calback
    }

    return (
        <div className=''>
            <ButtonHeading
                title={supplierName ? supplierName : supplierData?.name}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/supplier'); setMasterDetailsList({}) }} // navigate(-1)
                printButtonTitle={activeTab == 2 ? "Supplier Report" : ""}
                printOnClick={() => { setOpenDate(true) }}
                ledgerButtonTitle={activeTab == 4 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
            />

            <div className='addPr_flBx __sulpFlx_main'>
                <Tab {...tabProps} />
                {activeTab === 1 && <SupplierDetailsTab supplierDataFunc={handleSupplierData} supplierDetails={supplierData} />}
                {activeTab === 2 && <Trip hideHeaderSection={false} detailsData={supplierData} />}
                {activeTab === 3 && <PaymentDetailsTabs supplierDetails={supplierData} />}
                {activeTab === 4 && <Ledger type={1} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} supplierDataFunc={handleSupplierData} />}
                {activeTab === 5 && <SupplierSettingsTab />}
            </div>

            {openDate && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <div className="_divForth">
                            <CommonDateRange
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>
                    </>
                </ConfirmModalFor>
            )}

            {openForDownLoad && <SupplierReport {...TripReoprtModal} />}
            {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}

        </div>
    );
};

export default SupplierDetails;